var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgTrashCanFeedbackSuccess = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M30.598 16.93a1.376 1.376 0 0 1 1.175-1.55l12.094-1.7a1.376 1.376 0 0 1 1.556 1.167l.656 4.665a.432.432 0 0 1-.368.486l-13.969 1.963a.432.432 0 0 1-.488-.366l-.656-4.665Zm37.854 56.642a1.67 1.67 0 0 1-1.425 1.882l-40.483 5.69a1.676 1.676 0 0 1-1.897-1.422l-6.26-44.548a.433.433 0 0 1 .368-.487l42.941-6.035a.433.433 0 0 1 .488.366l6.262 44.555.006-.001Zm-3.838-45.33-48.777 6.855a.432.432 0 0 1-.488-.366l-1.095-7.791a2.501 2.501 0 0 1 2.136-2.82l44.238-6.218a2.94 2.94 0 0 1 3.326 2.494l1.035 7.358a.434.434 0 0 1-.375.488Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M33.33 18.371a1.376 1.376 0 0 1 1.174-1.551l10.305-1.458a1.376 1.376 0 0 1 1.557 1.167l.47 3.26a.432.432 0 0 1-.368.487l-12.467 2.545s-.168-.955-.2-1.19l-.472-3.26ZM68.141 72.91a1.67 1.67 0 0 1-1.425 1.882L30.84 79.806a1.676 1.676 0 0 1-1.896-1.422l-6.101-40.72a.432.432 0 0 1 .368-.486l38.638-5.805a.432.432 0 0 1 .488.366l5.798 41.17h.006Zm-3.963-44.66-44.118 6.884a.432.432 0 0 1-.488-.366l-1.095-7.791a2.501 2.501 0 0 1 2.136-2.82l38.552-6.083c1.608-.226 4.465-.375 4.869 2.494l1.139 6.39c.032.235-.753 1.258-.995 1.292Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M30.598 16.93a1.376 1.376 0 0 1 1.175-1.55l12.094-1.7a1.376 1.376 0 0 1 1.556 1.167l.656 4.665a.432.432 0 0 1-.368.486l-13.969 1.963a.432.432 0 0 1-.488-.366l-.656-4.665Zm37.854 56.642a1.67 1.67 0 0 1-1.425 1.882l-40.483 5.69a1.676 1.676 0 0 1-1.897-1.422l-6.26-44.548a.433.433 0 0 1 .368-.487l42.941-6.035a.433.433 0 0 1 .488.366l6.262 44.555.006-.001Zm-3.838-45.33-48.777 6.855a.432.432 0 0 1-.488-.366l-1.095-7.791a2.501 2.501 0 0 1 2.136-2.82l44.238-6.218a2.94 2.94 0 0 1 3.326 2.494l1.035 7.358a.434.434 0 0 1-.375.488Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-90)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m28.715 40.181 5.033 34.812M40.459 38.503l5.033 34.812M52.203 38.503l5.033 34.812"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m29.554 38.503 5.033 34.812M41.298 36.826l5.033 34.812M53.042 36.826l5.033 34.812"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M66.552 82.5c7.67 0 13.752-6.216 13.584-13.884-.168-7.668-6.521-13.884-14.191-13.884A13.526 13.526 0 0 0 52.36 68.616C52.53 76.284 58.883 82.5 66.552 82.5Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    stroke: "var(--color-neutral-70)",
    strokeWidth: 1.5,
    d: "M61.89 67.865a.472.472 0 0 0-.67 0 .478.478 0 0 0 0 .673l3.159 3.176a.472.472 0 0 0 .67 0l6.95-6.987a.478.478 0 0 0 0-.673.472.472 0 0 0-.67 0l-6.615 6.65-2.824-2.84Z",
    clipRule: "evenodd"
  }));
};
export default SvgTrashCanFeedbackSuccess;